var AdaptiveImage = require( "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/img_discount_title.26d192f3.png","uri@2x": __webpack_public_path__ + "static/media/img_discount_title.4fd965dd.png","uri@3x": __webpack_public_path__ + "static/media/img_discount_title.7909e175.png",
    width: 155,
    height: 30
});